import { combineReducers } from 'redux';

import { updated_calendar_data, updated_phone_mts_data, updated_phone_a1_data, updated_contact_data, updated_work_data } from './update_data';
import { header_is_visible, home_filter_value, navigation_menu_show } from './update_state';
import { site_options } from './options';

//комбинируем обработчики
export default combineReducers({
  updated_calendar_data,
  updated_phone_mts_data,
  updated_phone_a1_data,
  updated_contact_data,
  updated_work_data,

  header_is_visible,
  home_filter_value,
  navigation_menu_show,

  site_options
});